export var typography = {
  fonts: {
    body: 'Equip'
  },
  fontSizes: {
    '2xs': '0.6875rem',
    '3xl': '1.75rem',
    '4xl': '2rem'
  },
  fontWeights: {
    light: 300,
    regular: 500,
    medium: 600,
    bold: 700
  },
  lineHeights: {
    xs: '18px',
    sm: '24px',
    md: '28px',
    lg: '30px',
    xl: '36px',
    '2xl': '42px'
  }
};
//# sourceMappingURL=typography.js.map